import React, { useState, useEffect } from 'react';
import { Form, Sidebar, Segment, Button } from 'semantic-ui-react';
import { Reservations } from '../../api/services/next';
import { GetReservationTotals, GetGuestInHouseFilters, UpdateReservationStatuses } from '../../api/services/pms';
import { DatePicker } from '../../components/shared/DatePicker';
import TextInput from '../../components/shared/TextInput';
import { useTextResources, useMessageResources } from '../../language';
import GridSearchTemplate from '../../pages/GridSearchTemplate';
import moment from 'moment';
import { endpoint } from '../../api/http';
import ReservationStatusesDropDown from '../../components/shared/ReservationStatusesDropDown';
import GuestSearchDropDown from '../../components/shared/GuestSearchDropDown';
import WingDropDown from '../shared/WingDropDown';
import ReservationTypesDropDown from '../../components/shared/ReservationTypesDropDown';
import RoomTypesDropDown from '../../components/shared/RoomTypesDropDown';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import PropTypes from 'prop-types';
import DropDown from '../shared/dropdown';
import { Images } from '../../assets/assets';
import { currencyFormat } from '../../components/shared/utils';
import formatCurrency from 'format-currency';
import { Currencies } from '../../components/shared/currencies';
import { Popup } from 'semantic-ui-react'
import { RoomStatusTypes, MaintenanceStatusEnums, ReceptionStatusEnums, ReservationStatusTypes, ReservationStatusesEnums } from '../../components/shared/statustypes';
import ReservationSummary from '../ReservationSummary';
import { ConnectedRoomTypeEnum } from '../../components/shared/constants'
import { EditLocation } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import ReservationsUpdateStatusModal from './reservationsUpdateStatusModal';
import { useLoader } from '../shared/utils';
import { onError } from "../shared/messages";
import './style.css';

const ArrivalsAndGuestInHouseSearch = ({ IsGuestInHouse, HotelId }) => {
  const text = useTextResources();
  const message = useMessageResources();
  const loader = useLoader();

  const [hotelIds] = useState(HotelId ? [HotelId] : []);
  const currencyId = window.user?.CurrentHotel?.MainCurrencyId || 1
  const currentBusinessDate = moment(window.user?.CurrentHotel?.HotelParameter?.CurrentBusinessDate);

  const [guest, setGuest] = useState({});
  const [agents, setAgents] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [reservationStatuses, setReservationStatuses] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [vipTypes, setVipTypes] = useState([]);
  const [wings, setWings] = useState([]);

  const [data, setData] = useState([]);
  const [selectedReservation, setSelectedReservation] = useState();
  const [showInfo, setShowInfo] = useState(false);
  const [reservationsUpdateStatuses, setReservationsUpdateStatuses] = useState([]);
  const [showReservationsUpdateStatusModal, setShowReservationsUpdateStatusModal] = useState(false);
  const [selected, setSelected] = useState([]);

  const connectedRoomTypes = Object.entries(ConnectedRoomTypeEnum).map(x => {
    return {
      Id: x[0],
      Name: x[1]
    }
  })

  const arrivalHiddenColumns = [
    { columnName: 'RoomNumber' },
  ]

  const guestInHouseHiddenColumns = [
    { columnName: 'ArrivalDate' },
    { columnName: 'DepartureDate' },
    { columnName: 'VipName' },
    { columnName: 'VipDescription' },
    { columnName: 'ConnectedRoom' },
    { columnName: 'RoomType' },
    { columnName: 'Agent' },
    { columnName: 'Company' },
  ]

  const fmt = 'DD/MM/YYYY';

  const dateFormatter = ({ value }) => {
    return value ? moment(value).format(fmt) : "";
  };

  useEffect(() => {
    (async () => {
      const data = await GetGuestInHouseFilters({});
      if (data) {
        setAgents(data.Agents);
        setCompanies(data.Companies);
        setReservationStatuses(data.ReservationStatus);
        setRoomTypes(data.RoomTypes);
        setVipTypes(data.Vips);
        setWings(data.Wings);
      }
    })()
  }, [])

  const formatter = ({ value }) => {
    return value || ""
  }

  const reservationFormatter = ({ value, row }) => {
    if (row) {
      if (row.ReservationGroupId && !row.IsPartyGroup) {
        return (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`${endpoint}PMS/ReservationGroupDataService/ReservationGroup?groupid=${row.ReservationGroupId}&hotelid=${HotelId}`}
          >
            {value}
          </a>
        );
      }
      else {
        return (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`${endpoint}PMS/Reservations/Index/${row.Id}?hotelid=${HotelId}`}
          >
            {value}
          </a>
        );
      }
    }
    else return value || "";
  }
  const folioFormatter = ({ value, row }) => {
    return row ? (
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={`${endpoint}Finance/Folio/Folio?ReservationId=${row.Id}&hotelid=${HotelId}`}
      >
        {value}
      </a>
    ) : value || "";
  }
  const roomBlockingFormatter = ({ value, row }) => {
    return row ? (
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={`${endpoint}PMS/RoomsAllocation/Index?ReservationId=${row.Id}`}
      >
        {value}
      </a>
    ) : value || ""
  }

  const maintenanceStatusFormatter = ({ value }) => {
    return value ? text(MaintenanceStatusEnums[value]) : ""
  }

  const receptionStatusFormatter = ({ value }) => {
    return value ? text(ReceptionStatusEnums[value]) : ""
  }

  const reservationStatusFormatter = ({ value }) => {
    return value ? text(ReservationStatusTypes[value]) : ""
  }

  const guestFormatter = ({ value, row }) => {
    return row && row.GuestName ? (
      <Popup content={row.GuestName} trigger={<a
        target='_blank'
        rel='noopener noreferrer'
        href={`${endpoint}CRM/GuestProfile/index/?hotelid=${row.HotelId}#/profile/${row.GuestId}`}
      >
        {value}
      </a>} />
    ) : value || ""
  };

  const imageFormatter = ({ value, row }) => {
    return row ? (
      <input type="image" onClick={() => { openReservationSummary(row.Id) }} className="ui avatar image" src={row.Gender == 'F' ? Images.female_avatar : Images.male_avatar} />
    ) : value || "";
  };
  const checkInFormatter = ({ value, row }) => {
    return row ? (
      <a target='_blank' rel='noopener noreferrer' href={`${endpoint}PMS/Reservations/checkin/${row.Id}/?hotelid=${row.HotelId}`} >
        <span className={`ui avatar image status-icon checkIn`} />
      </a>
    ) : value || "";
  };

  const houseKeepingStatusFormatter = ({ value, row }) => {
    return row ?
      <span className={`status-icon ${RoomStatusTypes[value]}`}></span> : value ? text(capitalize(RoomStatusTypes[value])) : ""
  }

  const toolTipFormatter = ({ value, row }) => {
    return row ? (
      <Popup content={value} trigger={<div>{value}</div>} />) : value || ""
  };

  const currencyFormatter = ({ value }) => {
    return formatCurrency(value || 0, currencyFormat(currencyId, Currencies));
  }

  const onChangeGuestvalue = (value) => {
    if (!value?.toString().startsWith('newguest-')) {
      setGuest({ GuestId: value });
    }
  };

  const onSearchComplete = async (data) => {
    if (!data.length) {
      setData(data);
      return;
    }

    try {
      loader(true);
      const totals = await GetReservationTotals({
        ReservationIDs: data.map(r => r.Id),
        HotelID: data[0]?.HotelId || HotelId,
        TargetCurrencyId: currencyId
      });
      data.forEach(r => {
        const total = totals.find(t => t.ReservationID == r.Id);
        if (total) {
          r.TotalReservation = total.TotalAmountDebitAfterTax,
            r.TotalPayments = total.TotalAmountCreditAfterTax,
            r.Balance = total.TotalAmountDebitAfterTax + total.TotalAmountCreditAfterTax
        }
      })
      setData(data);
    }
    catch (error) {
      onError(error);
    }
    finally {
      setSelected([]);
      loader(false);
    }
  }

  const openReservationSummary = (id) => {
    setSelectedReservation(id);
    setShowInfo(true);
  }

  const capitalize = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  const ReservationsStatusesUpdateButton = () => (
    <Popup hoverable basic on='click' content={
      <Form style={{ padding: '5%' }}>
        <Button.Group className='statusButtonGroup'>
          <Button className='statusButton' color='green' disabled={!selected.length} size='medium' onClick={() => updateReservationsStatuses(2)} >{text('CheckIn')}</Button>
          <Button.Or text={text('Or')} />
          <Button className='statusButton' color='green' disabled={!selected.length} size='medium' onClick={() => updateReservationsStatuses(1)} >{text('uncheckin')}</Button>
        </Button.Group>
        <Button.Group className='statusButtonGroup'>
          <Button className='statusButton' color='blue' disabled={!selected.length} size='medium' onClick={() => updateReservationsStatuses(3)} >{text('CheckOut')}</Button>
          <Button.Or text={text('Or')} />
          <Button className='statusButton' color='blue' disabled={!selected.length} size='medium' onClick={() => updateReservationsStatuses(2)} >{text('uncheckout')}</Button>
        </Button.Group>
      </Form>}
      trigger={<IconButton size='medium'> <EditLocation /> </IconButton>
    } />
  );

  const addReservationToStatusUpdateOrPopulateErrorMesssage = (statusId, reservation, reservationsForStatusUpdate, errorMessages) => {

    if ((statusId == reservation.ReservationStatus) ||
      (statusId == ReservationStatusesEnums.Reserved && reservation.ReservationStatus != ReservationStatusesEnums.CheckedIn) ||
      (statusId == ReservationStatusesEnums.CheckedOut && reservation.ReservationStatus != ReservationStatusesEnums.CheckedIn)) {
      errorMessages.push({
        Number: reservation.ReservationNumber,
        RoomNumber: reservation.RoomNumber,
        GuestFullName: reservation.GuestName,
        ErrorMessages: message('ErrorReservationStatus')
      });
    }
    else {
      reservationsForStatusUpdate.push({
        Id: reservation.Id,
        CheckOutDate: reservation.CheckOutDate,
        IsBlockReservaton: reservation.IsBlockReservation,
        HotelId: reservation.HotelId,
        GuestFullName: reservation.GuestName,
        RoomNumber: reservation.RoomNumber,
        Number: reservation.ReservationNumber,
        ForcedStatusUpdate: statusId == ReservationStatusesEnums.CheckedIn || statusId == ReservationStatusesEnums.Reserved,
        RefetchReservation: true,
        StatusId: statusId,
        RoomId: reservation.RoomId
      });
    }
  }
  const updateReservationsStatuses = async (statusId) => {
    try {
      loader(true);
      const selectedReservations = [];
      const errorMessages = [];
      selected.forEach(i => {
        if (data[i]) {
          addReservationToStatusUpdateOrPopulateErrorMesssage(statusId, data[i], selectedReservations, errorMessages);
        }
      });
      const res = selectedReservations.length ? await UpdateReservationStatuses(selectedReservations) : [];
      setReservationsUpdateStatuses(res.concat(errorMessages));
      setShowReservationsUpdateStatusModal(true);
      res.forEach(updatedRes => {
        if (!updatedRes.ErrorMessages) {
          const index = data.map(e => e.Id).indexOf(updatedRes.Id);
          if (index > -1) {
            data[index].ReservationStatus = updatedRes.StatusId;
            data[index].CheckOutDate = updatedRes.CheckOutDate;
          }
        }
      });
      setData([...data]);
    }
    catch (error) {
      onError(error);
    }
    finally {
      loader(false);
    }
  }

  const closeReservationsUpdateStatusModal = () => {
    setReservationsUpdateStatuses([]);
    setShowReservationsUpdateStatusModal(false);
  }

  const gridOptions = {
    search: {
      fields: [
        <Form.Field
          control={HotelsDropDown}
          width="2"
          multiple
          clearable
          label={text("Hotel")}
          key="HotelIds"
        />,
        ...!IsGuestInHouse ? [<DatePicker
          label={text('ArrivalDate')}
          key='FromCheckInDate'
        />] : [],
        ...!IsGuestInHouse ? [<DatePicker
          label={text('ToDate')}
          key='ToCheckInDate'
        />] : [],
        <Form.Field
          key='GuestId'
          label={text('Guest')}
          width={3}
          clearable
          control={GuestSearchDropDown}
          placeholder={text('SearchByNameEmailPhoneId')}
          additionLabel={`${text('Search')}: `}
          onAddGuest={setGuest}
          onChange={onChangeGuestvalue}
        />,
        <Form.Field
          key='Number'
          label={text('ReservationNumber')}
          control={TextInput}
          buttonPlacement='none'
        />,
        <Form.Field
          key='Statuses'
          label={text('ReservationStatus')}
          placeholder={text('All')}
          multiple
          clearable
          data={reservationStatuses}
          control={ReservationStatusesDropDown}
        />,
        <Form.Field
          key='ReservationTypes'
          control={ReservationTypesDropDown}
          placeholder={text('All')}
          clearable
          multiple
          label={text('ReservationType')}
        />
      ],
      advancedFields: [

        ...!IsGuestInHouse ? [<Form.Field
          label={text("VIP")}
          key="VipId"
          textField="Name"
          valueField="Id"
          control={DropDown}
          data={vipTypes}
        />] : [],
        <Form.Field
          label={text("Wing")}
          key="WingId"
          control={WingDropDown}
          data={wings} />,
        ...!IsGuestInHouse ? [<Form.Field
          key='ConnectedRoom'
          textField="Name"
          valueField="Id"
          control={DropDown}
          placeholder={text('All')}
          data={connectedRoomTypes}
          label={text('ConnectedRoom')}
        />] : [],
        ...IsGuestInHouse ? [<Form.Field
          key='RoomNumber'
          label={text('RoomNumber')}
          control={TextInput}
          clearable
        />] : [],
        ...!IsGuestInHouse ? [<Form.Field
          key='RoomTypeId'
          label={text('RoomType')}
          placeholder={text('All')}
          HotelIDs={hotelIds}
          control={RoomTypesDropDown}
          clearable
          data={roomTypes}
        />] : [],

        ...!IsGuestInHouse ? [<Form.Field
          key='AgentId'
          textField="Name"
          valueField="Id"
          search={true}
          control={DropDown}
          placeholder={text('All')}
          data={agents}
          label={text('Agent')}
        />] : [],
        ...!IsGuestInHouse ? [<Form.Field
          key='CompanyId'
          textField="Name"
          valueField="Id"
          search={true}
          control={DropDown}
          placeholder={text('All')}
          data={companies}
          label={text('Company')}
        />] : [],
      ],
      method: 'POST',
      api: Reservations.SearchArrivalAndGuestInHouse,
      searchOnLoad: true,
      spec: {
        FreeText:
          (guest?.FirstName || guest?.LastName) &&
          `${guest?.FirstName} ${guest?.LastName}`,
        GuestId: guest?.GuestId?.toString().startsWith('newguest-')
          ? null
          : guest?.GuestId,
      },
      initial: hotelIds.length
        ? {
          HotelIds: hotelIds,
          FromCheckInDate: !IsGuestInHouse ? currentBusinessDate.toDate() : null,
          ToCheckInDate: !IsGuestInHouse ? currentBusinessDate.toDate() : null,
          Statuses: IsGuestInHouse ? [2] : [1, 6],
          ReservationTypes: [0, 2]

        }
        : null,
    },
    grid: {
      columns: [
        { name: 'GuestPhoto', title: (' '), formatter: imageFormatter },
        { name: 'CheckIn', title: (' '), formatter: checkInFormatter },
        { name: 'GuestName', title: text('Guest'), formatter: guestFormatter, },
        { name: 'ReservationNumber', title: text('ReservationNumber'), formatter: reservationFormatter },
        { name: 'FolioId', title: text('FolioNo'), formatter: folioFormatter },
        { name: 'TotalReservation', title: text('TotalReservation'), formatter: currencyFormatter },
        { name: 'TotalPayments', title: text('TotalPayments'), formatter: currencyFormatter },
        { name: 'Balance', title: text('Balance'), formatter: currencyFormatter },
        { name: 'RoomNumber', title: text('RoomNumber'), formatter: roomBlockingFormatter },
        { name: 'HouseKeepingStatus', title: text('HousekeepingStatus'), formatter: houseKeepingStatusFormatter },
        { name: 'ArrivalDate', title: text('ArrivalDate'), formatter: dateFormatter },
        { name: 'CheckOutDate', title: text('DepartureDate'), formatter: dateFormatter },
        { name: 'Guests', title: text('Guests'), formatter },
        { name: 'Agent', title: text('Agent'), formatter },
        { name: 'Company', title: text('Company'), formatter },
        { name: 'VipName', title: text('VipCode'), formatter },
        { name: 'VipDescription', title: text('VipDescription'), formatter: toolTipFormatter },
        { name: 'Gender', title: text('Gender'), formatter },
        { name: 'HotelName', title: ('Hotel'), formatter },
        { name: 'Wing', title: text('Wing'), formatter },
        { name: 'RoomType', title: text('RoomType'), formatter },
        { name: 'Eta', title: text('ETA'), formatter },
        { name: 'GroupReservationName', title: text('GroupReservationName'), formatter },
        { name: 'PartyReservationName', title: text('PartyReservationName'), formatter },
        { name: 'Rate', title: text('Rate'), formatter },
        { name: 'Product', title: text('Product'), formatter },
        { name: 'ReservationStatus', title: text('ReservationStatus'), formatter: reservationStatusFormatter },
        { name: 'Nationality', title: text('Nationality'), formatter },
        { name: 'ConnectedRoom', title: text('ConnectedRoom'), formatter },
        { name: 'AdjoinedRoom', title: text('AdjoinedRoom'), formatter },
        { name: 'Comments', title: text('Comments'), formatter: toolTipFormatter },
        { name: 'ReceptionStatus', title: text('ReceptionStatus'), formatter: receptionStatusFormatter },
        { name: 'MaintenanceStatus', title: text('MaintenanceStatus'), formatter: maintenanceStatusFormatter },
        { name: 'ArrivedTime', title: text('ArrivedTime'), formatter },
        { name: 'MinutesPassed', title: text('MinutesPassed'), formatter },
        { name: 'Voucher', title: text('Voucher'), formatter },
        { name: 'MarketSegment', title: text('MarketSegment'), formatter },
        { name: 'ReservationSource', title: text('ReservationSource') },
        { name: 'DateOfBirth', title: text('DateOfBirth'), formatter: dateFormatter },
        { name: 'City', title: text('City'), formatter },
        { name: 'Language', title: text('Language'), formatter },
      ],
      cacheId: `${IsGuestInHouse ? 'GuestInHouse' : 'Arrivals'}Search`,
      customOptions: {
        sort: {},
        group: {
          extensions: [
            { columnName: 'GuestPhoto', groupingEnabled: false },
            { columnName: 'CheckIn', groupingEnabled: false }
          ]
        },
        order: {},
        hidden: {
          hiddenColumns: IsGuestInHouse ? guestInHouseHiddenColumns : arrivalHiddenColumns,
          toggleHidden: true,
          columnsExtensions: [{ columnName: 'GuestPhoto', togglingEnabled: false }, { columnName: 'CheckIn', togglingEnabled: false }]
        }
      },
      leftColumns: ['GuestPhoto', 'CheckIn', 'GuestName'],
      noVirtualTable: true,
      columnExtensions: [
        { columnName: 'GuestPhoto', width: '4em' },
        { columnName: 'CheckIn', width: '4em' },
      ],
      paging: true,
      selectable: true,
      menu: [
        <ReservationsStatusesUpdateButton key="UpdateReservationStatuses" />
      ],
    },
  };
  return (
    <Sidebar.Pushable className="sidebarPusher" >
      <Sidebar
        visible={showInfo}
        width="wide"
        animation='overlay'
        onHide={() => { setShowInfo(false) }}
        as={Segment}
        direction="left">
        <ReservationSummary
          ReservationID={selectedReservation}
          HotelID={HotelId}
          Currency={currencyId}
          FolioId={data.find(item => item.Id === selectedReservation)?.FolioId}
        />
      </Sidebar>
      <Sidebar.Pusher dimmed={showInfo} style={{ display: 'flex' }}>
        <GridSearchTemplate options={gridOptions} onSelected={setSelected} onSearchComplete={onSearchComplete} data={data} />
        {showReservationsUpdateStatusModal && <ReservationsUpdateStatusModal
          startOpen={showReservationsUpdateStatusModal}
          onClose={closeReservationsUpdateStatusModal}
          data={reservationsUpdateStatuses} />}

      </Sidebar.Pusher>
    </Sidebar.Pushable>
  )
};

ArrivalsAndGuestInHouseSearch.propTypes = {
  IsGuestInHouse: PropTypes.bool,
  HotelId: PropTypes.any
};
export default ArrivalsAndGuestInHouseSearch;
